import { DOMAttributes, PropsWithChildren } from 'react'
import Styles from './Grid.module.scss'

export const Root = (props: PropsWithChildren) => <div {...props} className={Styles.grid} />

export const Cell = (props: PropsWithChildren) => <div {...props} className={Styles.gridCell} />

export const Thumbnail = (props: PropsWithChildren<DOMAttributes<HTMLDivElement>>) => (
  <div {...props} className={Styles.thumbnail} />
)

export const Grid = {
  Root,
  Cell,
  Thumbnail,
}
